export const site = {
  siteName: "AutomationTK",
  brandEmail: "hello@automationtk.com",
  supportEmail: "support@automationtk.com",
  calendarBookingUrl: "https://calendar.app.google/mUEkUJRJ43zszjrVA",
  bookingEmbedUrl:
    "https://calendar.google.com/calendar/appointments/schedules/AcZssZ3rBMv2Xhh-hjgeX5iGhVXp9h-sKe7MKMQUBLUpYQg0e0MBadcukOLKhkJNT7zYAy-chFf0xvcz?gv=true",
  zoomWebinarUrl: "",
  googleSheetsIntegrationEnabled: false,
  zoomRegistrationEnabled: false,
  analyticsEnabled: false,
  domain: "automationtk.com",
  legalEntityName: "AutomationTK",
} as const;

export type SiteConfig = typeof site;
